import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import msgConstants from '../../../../constants/msgConstants'
import { PAGES } from '../../../../router/routes'
import { loadingReset, loadingUpdate } from '../../../../store/actions/loadingAction'
import { RegraNotaFiscal } from '../../../../types/notaFiscalApiTypes'
import { converterToAcaoNotaFiscalForm, converterToCondicaoNotaFiscalForm } from '../../../../utils/regraFormsUtils'
import notaFiscalManager from '../../../../services/api/notaFiscal/notaFiscalManager'
import { itemNotaFiscalStyles } from './ItemNotaFiscal.style'
import { ItemNotaFiscalProps } from './ItemNotaFiscal.View'

export function itemNotaFiscalIO({ atualizarDados }: ItemNotaFiscalProps) {
  const dispatch = useDispatch()
  const router = useHistory()
  const { parceiroId } = useParams<{ parceiroId: string }>()
  const [abrir, setAbrir] = useState(false)
  const [ancoraAtiva, setAncoraAtiva] = useState<null | HTMLElement>(null)

  const handleAlterarIconeAncora = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAncoraAtiva(event.currentTarget)
  }

  const handleAnularIconeAncora = () => {
    setAncoraAtiva(null)
  }

  const desativarRegraNotaFiscal = (data: RegraNotaFiscal) => {
    dispatch(loadingUpdate(true))
    const dataEdit = {
      ...data,
      ativo: !data.ativo,
      acoes: converterToAcaoNotaFiscalForm(data.acoes),
      condicoes: converterToCondicaoNotaFiscalForm(data.condicoes)
    }

    notaFiscalManager
      .editarRegra(dataEdit, parceiroId, dataEdit.regraId)
      .then(() => {
        toast.success(msgConstants.USO_GENERICO.desativar_sucesso)
        atualizarDados()
      })
      .catch((error: Error) => {
        toast.error(error.message)
      })
    dispatch(loadingReset())
  }

  const editarRegraNotaFiscal = (regraSelecionada: RegraNotaFiscal) => {
    router.push(PAGES.transformacaoNotaFiscalEditar(parceiroId, String(regraSelecionada.regraId)))
  }

  return {
    styles: itemNotaFiscalStyles,
    abrir,
    handleAbrirToogle: () => setAbrir(!abrir),
    ancoraAtiva,
    handleAlterarIconeAncora,
    handleAnularIconeAncora,
    editarRegraNotaFiscal,
    desativarRegraNotaFiscal,
    parceiroId
  }
}

export type ItemNotaFiscalIO = ReturnType<typeof itemNotaFiscalIO>
